<template>
    <div>
        <b-input-group>
            <b-form-input placeholder="Enter text to search" autocomplete="off" :readonly="hasSelected"
                          @input="handler"
                          v-model="value"></b-form-input>
            <b-input-group-append>
                <span class="input-group-text" :class="inputIconClass" @click="removeSelected"></span>
            </b-input-group-append>
        </b-input-group>

        <div v-if="showResult && !hasSelected">
            <auto-complete-result v-on:selected="selectedItem" :result="result"></auto-complete-result>
        </div>
    </div>
</template>

<script>
  import AutoCompleteResult from './AutoCompleteResult';
  import {get} from '@/api';

  export default {
    props: {
      handler: {
        type: Function
      },

      result: {
        type: Array,
        default: () => []
      },

      reset: {
        type: Boolean,
        default: false
      },

      showResult: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        value: null,
        hasSelected: false,
        forceShow: false
      };
    },

    components: {
      AutoCompleteResult
    },

    computed: {
      inputIconClass() {
        return this.hasSelected ? 'dripicons-cross' : 'dripicons-search';
      }
    },

    methods: {
      removeSelected() {
        this.value = null;
        this.hasSelected = false;
        this.$emit('hasSelected', null);
      },

      /**
       * Selected item
       *
       * @param item
       */
      selectedItem(item) {
        this.value = item.value;
        this.hasSelected = true;
        this.forceShow = false;
        this.$emit('hasSelected', item);
      }
    },

    watch: {
      'reset'(newVal) {
        if (newVal) {
          this.removeSelected();
        }
      }
    }
  }
</script>

<style scoped>
    .dripicons-cross {
        color: #ff0002;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/views/Common/AutoComplete/AutoCompleteSearch.vue